import React from "react";
import { useEffect, useState,useCallback,useRef } from "react";
import * as Survey from "survey-react";
import cogoToast from "cogo-toast";
import { useReactToPrint } from 'react-to-print';
 
import { Spinner } from "reactstrap";
import {
  getTemplate,
  RequestLabTest,
  listHospitalRooms,
} from "../../services/Api";

import {
  
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
 
} from 'reactstrap';

import { genericGet, genericPost } from "../../services/Api";
import { SUCCESS_RESULT, ENDPOINTS, LOCAL_PATHS } from "../../Constants";

import { useHistory } from "react-router-dom";

import "survey-react/survey.css";
const RedeemPrescription = (props) => {
  const history = useHistory();
  const { patient_info, room } = (props.location && props.location.state) || {};
  const [template, setTemplate] = useState(null);
  const [Isloading, setIsloading] = useState(false);
  const [started, setSaterted] = useState();
  const [LabRoomID, setLabRoomID] = useState(null);
  const componentRef = useRef();
const [Active_cycles, setActive_cycles] = useState([])
  const [prescribed_items, setprescribed_items] = useState([
    {
        "drug_id": "67f8815f-dd3b-4e41-880b-f6182bd040f1",
        "drug": "Insulin",
        "mode_of_application": "1x2",
        "remarks": "ac5"
    },
    {
        "drug_id": "aff2a93d-4955-4a2b-ae93-edd7c60d4007",
        "drug": "Amoxicillin",
        "mode_of_application": "2x4",
        "remarks": "a4"
    },
    {
        "drug_id": "b847e30c-4f34-4a1f-8e7c-3d791c2c6be5",
        "drug": "Aspirin",
        "mode_of_application": "2x1",
        "remarks": "b4"
    }
])
  const [state, setstate] = useState(null)
  const [Ir_Redemption, setIr_Redemption] = useState(0);
  const [wallet_balance, setWallet_balance] = useState(15);
  const [cycle_id, setCycle_id] = useState(null)
  const [Bnf_Cash, setBnf_Cash] = useState(0)
  const [voucher_no, setVoucher_no] = useState(0)
  const [otp, setOtp] = useState(null)
  const [data, setdata]= useState(null);
//   const [data, setdata] = useState( {
//         "bnf_name": "Fardowsa Omar Mohamed",
//         "visit_number": 2,
//         "health_facility": "Shibis",
//         "health_facility_telephone": "+623123456",
//         "date_of_birth": "1994-01-01",
//         "id": "5dcadaf8-60c2-42b3-9942-2e6c308cfc44",
//         "prescription_id": "5dcadaf8-60c2-42b3-9942-2e6c308cfc44",
//         "voucher": "33962127",
//         "prescribed_items": [
//             {
//                 "drug_id": "67f8815f-dd3b-4e41-880b-f6182bd040f1",
//                 "drug": "Insulin",
//                 "mode_of_application": "1x2",
//                 "remarks": "ac5"
//             },
//             {
//                 "drug_id": "aff2a93d-4955-4a2b-ae93-edd7c60d4007",
//                 "drug": "Amoxicillin",
//                 "mode_of_application": "2x4",
//                 "remarks": "a4"
//             },
//             {
//                 "drug_id": "b847e30c-4f34-4a1f-8e7c-3d791c2c6be5",
//                 "drug": "Aspirin",
//                 "mode_of_application": "2x1",
//                 "remarks": "b4"
//             }
//         ],
//         "prescribed_at": "2024-04-29T06:25:08.000000Z",
//         "doctor": "Mohamed Nur Abdullahi",
//         "active_schemes": [
//             {
//                 "cycle_id": "3bf739d7-c9e9-4e04-913a-eb3973479591",
//                 "cycle_name": "Test Health Scheme Jun\/July2024",
//                 "entitlement": "{\"cash\": {\"qty\": 1, \"price\": \"50\", \"total\": 50}}",
//                 "start_date": "2024-04-22 00:00:00",
//                 "end_date": "2024-06-06 00:00:00",
//                 "voucher_bio_required": 10001,
//                 "receipt_bio_required": 10001,
//                 "has_voucher": 10001,
//                 "wallet_balance": 0.29999999999999716
//             },
//             {
//                 "cycle_id": "5297f9bf-1c27-4703-8f1d-b6cf19364979",
//                 "cycle_name": "Health Scheme - Out Patients",
//                 "entitlement": "{\"cash\": {\"qty\": 1, \"price\": \"15\", \"total\": 15}}",
//                 "start_date": "2024-04-21 00:00:00",
//                 "end_date": "2024-04-30 00:00:00",
//                 "voucher_bio_required": 10001,
//                 "receipt_bio_required": 10001,
//                 "has_voucher": 10001,
//                 "wallet_balance": 15
//             },
//             {
//                 "cycle_id": "82f233e1-886a-4bf7-a608-4f6e2da5de4c",
//                 "cycle_name": "Test Health Scheme April\/May 2024",
//                 "entitlement": "{\"cash\": {\"qty\": 1, \"price\": \"20\", \"total\": 20}}",
//                 "start_date": "2024-04-22 00:00:00",
//                 "end_date": "2024-04-30 00:00:00",
//                 "voucher_bio_required": 10001,
//                 "receipt_bio_required": 10001,
//                 "has_voucher": 10001,
//                 "wallet_balance": 10
//             }
//         ]
//     }
// );
const [masked_phone, setmasked_phone] = useState(null);
const [show_verify_dialog, setshow_verify_dialog] = useState(false)
const [redeem_receipt, set_redeem_receipt] = useState(null);
//   const [redeem_receipt, set_redeem_receipt] = useState({
//     "id": "846d0c3a-aba9-4eb3-aa19-67baa2a2a03d",
//     "created_by": 474,
//     "project_id": "836ebcbb-0759-4467-944a-97f0d10f5d81",
//     "template_id": "3bf739d7-c9e9-4e04-913a-eb3973479591",
//     "projectbeneficiary_id": "94b1f68e-0343-4f2c-9ec3-d3871dc7d3a4",
//     "entitlement": "{\"bnf_cash\": 7.700000000000003, \"discount_allowed\": 0, \"ir_redeemed_amount\": 0.29999999999999716, \"prescription_serviced\": [{\"drug\": \"Warfarin\", \"amount\": \"3\", \"drug_id\": \"7ebea71c-31f2-453e-94f2-6e854d4fa055\", \"remarks\": \"xxx\", \"mode_of_application\": \"1x2\"}, {\"drug\": \"Amoxicillin\", \"amount\": \"5\", \"drug_id\": \"aff2a93d-4955-4a2b-ae93-edd7c60d4007\", \"remarks\": \"xxx\", \"mode_of_application\": \"2x4\"}]}",
//     "reference": "57762505",
//     "status": 10001,
//     "redeemed_status": 10001,
//     "version": 1,
//     "created_at": "2024-05-02T11:32:08.000000Z",
//     "updated_at": "2024-05-02T11:32:08.000000Z",
//     "receipt_no": "2sl8qjczbS",
//     "voucher_time": "2024-05-02 13:29:21",
//     "receipt_time": "2024-05-02 14:32:08",
//     "assigned_center_id": "03a0c3c5-ffc6-11ee-8621-0a9ea65235cc",
//     "served_center_id": "03a0c3c5-ffc6-11ee-8621-0a9ea65235cc",
//     "receipted_by": 474,
//     "project_components_id": "b0dabb49-3dc1-4a18-ba0a-34e922277074",
//     "project_components_cycle_id": "3bf739d7-c9e9-4e04-913a-eb3973479591",
//     "child_id": null,
//     "sync_token": "iHtgXxx9WC55eVUzHtC2oLlPxuhnv8xC"
// })
  const toggle = () => setshow_verify_dialog(!show_verify_dialog);

const [send_otp_loading, setsend_otp_loading] = useState(false);
const [verify_otp_loading, setverify_otp_loading] = useState(false);
const [timer, setTimer] = useState(0);    
const timeOutCallback = useCallback(() => setTimer(currTimer => currTimer - 1), []);

const list_active_cycles = () => {
    
  // setIsloading(true)
 
 genericGet(ENDPOINTS.GET_ACTIVE_CYCLES)
 .then((res) => {
  //  setIsloading(false)

     if (res.status == 200) {
         if (res.data.status == SUCCESS_RESULT) {
             let responseData = res.data.data;
         setActive_cycles(responseData);
           
            
       
         } else {
             cogoToast.error(res.data.message, {});
             

         }
     }
 })
 .catch((err) => {
   setIsloading(false)
     cogoToast.error(err, {});

     console.log(err);
 });

};
useEffect(() => {

  list_active_cycles();

  // timer > 0 && setTimeout(timeOutCallback, 1000);

}, []);
const resetTimer = function () {
  if (!timer) {
    setTimer(60);
  }
};

  const update_amount = (drug_id,amount) => {
    let drugs=prescribed_items;
    drugs.forEach((d)=>{
      if(d.drug_id==drug_id){
       d["amount"]=amount
      }
    })
 setprescribed_items(drugs);
 get_payments();
 setTimeout(() => {
  setstate(Date.now())
 }, 500);

  };

  const get_total = () => {
  let total=0;
    prescribed_items.forEach((d)=>{
        if(d.amount){
        total=Number(total)+ Number(d.amount);
      }
    });
   return total;
  }

    const get_payments = () => {
      let total= get_total();
       if(total<=wallet_balance){
setIr_Redemption(total);
       }
       else
       {
        let ir_redump=Number(wallet_balance);
        setIr_Redemption(ir_redump);
        setBnf_Cash(Number(total)-Number(wallet_balance))
         
       }
     
       setstate(Date.now());
 
  };

  const get_lab_room = () => {
    let lab = JSON.parse(localStorage.getItem("rooms"))?.filter((obj) => {
      return obj.serial_no === 10;
    })[0];
    return lab;
  };

  const getConsultationRooms = (e) => {
    setIsloading(true);
    listHospitalRooms({ hospital_id: room.hospital_id })
      .then((res) => {
        setIsloading(false);

        if (res.status == 200) {
          var response = res.data;
          if (response.status == SUCCESS_RESULT) {
            response.data?.map((r) => {
              if (r.serial_no == 10) {
                setLabRoomID(r.id);
              }
            });

 
          } else {
            cogoToast.error(res.data.message, {
              hideAfter: 5,
            });
          }
        }
      })
      .catch((err) => {
        setIsloading(false);
        console.log(err);
        cogoToast.error("Something went wrong, please Try again. ", {
          hideAfter: 5,
        });
      });
  };
  const _submit = (form_result) => {
    console.log(form_result.valuesHash);

    let payload = {
      visit_id: patient_info.visit_id,
      from_room_id: room.room_id,
      room_id: LabRoomID,
      lab_request: { lab: JSON.stringify(form_result.valuesHash.lab) },
      lab_result: null,
    };
    console.clear();
    console.log(payload);

    setIsloading(true);
    RequestLabTest(payload)
      .then((res) => {
        setIsloading(false);
        var response = res.data;

        console.log(res);
        if (res.status == 200) {
          if (response.status == SUCCESS_RESULT) {
            console.log(response);

            cogoToast.success("Lab Request Created Successfully", {
              hideAfter: 5,
            });
            //   history.push({
            //     pathname: "/hmis/print-visit",
            //     state: {
            //       visit: response.data,

            //     },
            //   });
          } else {
            cogoToast.error(res.data.message, {
              hideAfter: 5,
            });
          }
        }
      })
      .catch((err) => {
        setIsloading(false);
        console.log(err);
        cogoToast.error("Something went wrong, please Try again. ", {
          hideAfter: 5,
        });
      });
  };

  

  

  const getLabRequestTemplate = () => {
    setIsloading(true);

    getTemplate({ template_name: "lab-test-request" })
      .then((res) => {
        console.log(res);
        setIsloading(false);

        if (res.status == 200) {
          var response = res.data;

          let tmp = response.data[0].template;
          setTemplate(tmp);

          if (response.status == SUCCESS_RESULT) {
          } else {
            cogoToast.error(res.data.message, {
              hideAfter: 5,
            });
          }
        }
      })
      .catch((err) => {
        setIsloading(false);
        console.log(err);
        cogoToast.error("Something went wrong, please Try again. ", {
          hideAfter: 5,
        });
      });
  };
 
const redeem = (voucher_no) => {
    
  let payload= {
    "service_center_id": "03a0c3c5-ffc6-11ee-8621-0a9ea65235cc",
    "prescription_id": data?.prescription_id,
    "cycle_id":cycle_id,
    "prescription_serviced":  prescribed_items,
    "ir_redeemed_amount":Ir_Redemption,
    "bnf_cash":Bnf_Cash,
    "discount_allowed":0,
    
};


setIsloading(true)
 genericPost(ENDPOINTS.REDEEM_PRESCRIPTION ,payload)
 .then((res) => {
   setIsloading(false)
     if (res.status == 200) {
         if (res.data.status == SUCCESS_RESULT) {
             let responseData = res.data.data;
             console.clear();
             console.log("Data Sent",data)
             console.log("Redemption status",responseData)
          set_redeem_receipt(responseData);
          setdata(null);
            
         } else {
             cogoToast.error(res.data.message, {});
         }
     }
 })
 .catch((err) => {
   setIsloading(false)
     cogoToast.error(err, {});
     console.log(err);
 });

};


const check_voucher = (voucher_no) => {
  setIsloading(true)
  let data={
   "search_phrase": voucher_no,
   "search_type": "voucher"
};
 genericPost(ENDPOINTS.GET_PRESCRIPTION_VOUCHER ,data)
 .then((res) => {
   setIsloading(false)
     if (res.status == 200) {
         if (res.data.status == SUCCESS_RESULT) {
             let responseData = res.data.data;
              setmasked_phone(responseData.telephone);
              setshow_verify_dialog(true);
         } else {
             cogoToast.error(res.data.message, {});
         }
     }
 })
 .catch((err) => {
   setIsloading(false)
     cogoToast.error(err, {});

     console.log(err);
 });
}

const handlePrint = useReactToPrint({
  content: () => componentRef.current,
});


const send_otp = (voucher_no) => {
 setsend_otp_loading(true);
  genericPost(ENDPOINTS.REQUEST_VOUCHER_VERIFICATION ,{
    "voucher": voucher_no
})
    .then((res) => {
      setIsloading(false)
      setsend_otp_loading(false);

        if (res.status == 200) {
          
          resetTimer();

            if (res.data.status == SUCCESS_RESULT) {
              cogoToast.success(res.data.message, {});
            } else {
                cogoToast.error(res.data.message, {});
            }
        }
    })
    .catch((err) => {
      setIsloading(false)
      setsend_otp_loading(false);

        cogoToast.error(err, {});

        console.log(err);
    });
}


  const get_voucher = (voucher_no,otp) => {
    
    setverify_otp_loading(true);
     setIsloading(true)
     let data={
      "voucher": voucher_no,
      "reference": "n/a",
      "verify_by":"center"
  };
    genericPost(ENDPOINTS.VERIFY_VOUCHER ,data)
    .then((res) => {
    
      setverify_otp_loading(false);

      setIsloading(false)
        if (res.status == 200) {
          
            if (res.data.status == SUCCESS_RESULT) {
              setshow_verify_dialog(false);
                let responseData = res.data.data;
                setdata(responseData);
                setprescribed_items(responseData.prescribed_items);
             
                setTemplate(responseData);
               
            } else {
                cogoToast.error(res.data.message, {});
            }
        }
    })
    .catch((err) => {
      setIsloading(false)
        cogoToast.error(err, {});
        setverify_otp_loading(false);

        console.log(err);
    });
   
  };
  return (
    <div className="p-10 w-80" style={{width:"60% !important",margin:"auto"}}>
     
      <h1 className="alert alert-primary">
    REDEEM PRESCRIPTION  
            </h1>
      

            <div className="input-group">
       
       <br/>
         <input
           type="text"
           placeholder="Enter Voucher Number"
           className="form-control search-input"
           autocomplete="off"
           onChange={(e) => setVoucher_no(e.target.value)}
           onKeyDown={(e) => {
             if (e.key === "Enter") {
             //  finPatient();
             }
           }}
         />

<button  className="btn search-button"  onClick={() =>get_voucher(voucher_no)  } type="button"> FIND </button>
        
       </div>

      <hr />
      <hr />
      <div className="d-flex justify-content-center my-1">
        {Isloading && <Spinner />}
      </div>
     
     
      <select className="form-control" onChange={(e)=>{

let balance=Active_cycles.filter((s)=>s.cycle_id==e.target.value)[0]?.wallet_balance;

setWallet_balance(15);
setCycle_id(e.target.value);


}}>
<option>..</option>
{Active_cycles?.map((s)=>{
  return   <option value={s.cycle_id} >{s.cycle_name}</option>
})}

</select>
     
      {data != null && (
         <>      
         <div className="alert alert-primary">
 Patient Name :<b>{data?.bnf_name}</b>
&nbsp;&nbsp;&nbsp;
 VISIT NO. :<b>{data?.visit_number}</b>
 &nbsp;&nbsp;&nbsp;
 FACILITY : <b>{data?.health_facility}</b>
 &nbsp;&nbsp;&nbsp;
 D.O.B : <b>{data?.date_of_birth}</b>
 </div>

 <div className="alert alert-primary">
Select Scheme <br/>


 </div>


         
         <h1>Drags</h1>

 



       { cycle_id!=null &&  <table className="info_table white-bg"  >
<thead>
  <th>No.</th>
  <th>Drug</th>
  <th>Mode of application</th>
  <th>Remarks</th>
  <th>Amount</th>
</thead>

<tbody>
  
  {prescribed_items?.map((p,i)=>{
return  <tr>

  <td>{i+1}</td> <td><b>{p?.drug}</b></td> <td>{p?.mode_of_application}</td><td>{p?.remarks}</td> 
<td><input type="text" style={{fontWeight:"bold"}} 
 
onChange={(e)=>update_amount(p?.drug_id,e.target.value)} className="form-control"></input></td>
</tr> 
  })}
<tr>
  <td colSpan={4}></td>
  
  <td> <button className=" btn-success w-100" onClick={()=> {
    
  get_payments(); 
  setstate(Date.now());

  }}>CALCULATE</button> </td>

</tr>
<tr>
  <td colSpan={3}></td>
  <td style={{textAlign:"right"}}>Total</td>
  <td> &nbsp;&nbsp;&nbsp;   <b>{  get_total()  } </b>  </td>

</tr>

<tr>
  <td colSpan={3}></td>
  <td style={{textAlign:"right"}}>Discount</td>
  <td></td>

</tr>
<tr>
  <td colSpan={3}></td>
  <td style={{textAlign:"right"}}>Net Total</td>
  <td> &nbsp;&nbsp;&nbsp;   <b>{  get_total()  } </b> </td>

</tr>
<tr>
  <td colSpan={3}></td>
  <td style={{textAlign:"right"}}>IR Redemption</td>
  <td>
  &nbsp;&nbsp;&nbsp; {Ir_Redemption}
  </td>

</tr>
<tr>
  <td colSpan={3}></td>
  <td style={{textAlign:"right"}}>Beneficiary Cash</td>
  <td>
  &nbsp;&nbsp;&nbsp; {Bnf_Cash}
  </td>

</tr>
<tr>
  <td colSpan={4}></td>
  
  <td> <button className="btn btn-primary w-100" onClick={()=> redeem()}>REDEEM VOUCHER</button> </td>

</tr>
</tbody>

         </table>

}
         
         {/* {JSON.stringify(data)} */}
         </>
      )}


 {redeem_receipt  && 
 <>
 <button
            type="button"
            className="btn btn-default"
            onClick={handlePrint}
            
          >
           
            Print
          </button>
  <div         className="visitPrint w50 white-bg"
        style={{ width: "450px", margin: "auto" }}>
<div
      style={{ width: "450px", margin: "auto" }}
        ref={componentRef}
      >



<center><h1>

{data?.health_facility} 
</h1>
<hr/>
<h1> REDEMPTION  RECEIPT </h1>
<hr/>
<h3>Name : {data?.bnf_name} </h3>
<h3>Reference No : <b>{redeem_receipt?.reference} </b> </h3>


</center>
 

 <table className="info_table  "  >
<thead>
  <th>No.</th>
  <th>Drug</th>
  <th>Mode of application</th>

  <th>Remarks</th>
  <th>Amount</th>
</thead>

<tbody>
  
  {JSON.parse(redeem_receipt?.entitlement).prescription_serviced?.map((p,i)=>{
return  <tr>

  <td>{i+1}</td> <td><b>{p?.drug}</b></td> <td>{p?.mode_of_application}</td>
  <td>{p?.remarks}</td> 
  <td>{p?.amount}</td> 


 
</tr> 
  })}
 
<tr>
  <td colSpan={3}></td>
  <td style={{textAlign:"right"}}>Total</td>
  <td> <b> {  Number(JSON.parse(redeem_receipt?.entitlement).ir_redeemed_amount)+Number(JSON.parse(redeem_receipt?.entitlement).bnf_cash)  } </b>  </td>

</tr>

 
 
<tr>
  <td colSpan={3}></td>
  <td style={{textAlign:"right"}}>IR Redemption</td>
  <td>
  &nbsp;&nbsp;&nbsp; {JSON.parse(redeem_receipt?.entitlement).ir_redeemed_amount}
  </td>

</tr>
<tr>
  <td colSpan={3}></td>
  <td style={{textAlign:"right"}}>Beneficiary Cash</td>
  <td>
  {JSON.parse(redeem_receipt?.entitlement).bnf_cash}
  </td>

</tr>
 
</tbody>

         </table>
</div>
</div>
 


 </>}





 <Modal
        isOpen={show_verify_dialog}
        onHide={() => setshow_verify_dialog(false)}
        
        backdrop={true}
      
      >
        <ModalHeader  toggle={toggle}>
          <div className="row">
             
             Verify Voucher
               
               
          </div>
           
          
          
         </ModalHeader>
        <ModalBody>
      
      <h2>

         <b>To  Verify Voucher #{voucher_no}</b> <br/>
         <br/>
      (1)   Send TOP to : <b>{masked_phone}</b>  &nbsp; &nbsp; <button className="btn badge bg-blue"  
         onClick={() =>  send_otp(voucher_no)} disabled={timer>0 || send_otp_loading }>{timer>0? <i>You can resend in {timer}s</i>:"SEND OTP"} {send_otp_loading && <b>(sending...)</b>}   </button>  <br/>

<br/>
(2) Enter OTP Code and verify
</h2>
         <div className="input-group">
       
       <br/>
         <input
           type="text"
           placeholder="Enter OTP Number"
           className="form-control search-input"
           autocomplete="off"
           onChange={(e) => setOtp(e.target.value)}
           onKeyDown={(e) => {
             if (e.key === "Enter") {
             //  finPatient();
             }
           }}
         />

<button  className="btn search-button"  disabled={verify_otp_loading}  onClick={() => get_voucher(voucher_no,otp)} type="button"> {verify_otp_loading?"Verifying..":"Verify"}  </button>
        
       </div>
       
           
        </ModalBody>
      
      </Modal>
    </div>
  );
};
 
export default RedeemPrescription;
